module.exports = __webpack_public_path__ + "media/img/ecopic_327729-6bfbca79.jpg";